import { AI_API } from 'utils/globalApiServices';
import Organization from 'infrastructure/Organization';

export async function getQuestionsService({ module_uuid }) {
  const org_id = Organization.getSelectedOrg()?.id;
  const url = `/orgs/${org_id}/training/mcqs/module/${module_uuid}`;
  const { data } = await AI_API.get(url);
  return data || [];
}

export async function getTrainingModuleIngestion({ module_uuid = 0 }) {
  const org_id = Organization.getSelectedOrg()?.id;
  const url = `/ingestion/orgs/${org_id}/training/modules/${module_uuid}?status=SUCCEEDED`;
  const { data } = await AI_API.get(url);
  return data || [];
}

export async function createQuestionsService({ module_uuid = 0, body = {}, regenerate = false }) {
  const org_id = Organization.getSelectedOrg()?.id;
  const url = `/orgs/${org_id}/training/mcqs/module/${module_uuid}/`;
  const { data } = await AI_API.post(url, { ...body });
  return data || [];
}
